<template>
  <section class="section regular store-tips">
    <div class="title bold">
      <div>{{ $t('foot.descriptionTitle') }}</div>
    </div>
    <div class="tips-content hide-da">
      ·
      {{ $t(`game.productDescription_${$store.state.app.gameId}`) }}
      <span @click="userTips = true" class="btn-link">{{ $t('game.tips') }}</span>
    </div>
    <div v-if="showDesc && !isRuShop" class="tips-content">· {{ $t('game.selectTips') }}</div>
    <div class="tips-content" v-html="'· ' + $t(notificationKey)"></div>
    <!-- <div v-else class="tips-content" v-html="'· ' + $t('foot.p2')"></div> -->
    <div
      class="tips-content hide-tt"
      v-html="'· ' + $t(`game.PayTips2_${$store.state.app.gameId}`)"
    ></div>
    <div class="tips-content" v-html="'· ' + $t('game.PayTips3')"></div>
    <div class="tips-content" v-html="'· ' + $t('game.PayTips4')"></div>
    <div
      class="tips-content"
      v-html="'· ' + $t(`game.payTipsContactUs_${$store.state.app.gameId}`)"
    ></div>

    <ImgTips v-if="userTips" @close="userTips = false">
      <div class="user-tips" @click.stop>
        <div class="img" :class="$i18n.locale"></div>
      </div>
    </ImgTips>
  </section>
</template>

<script>
import ImgTips from '@/components/common/imgTips.vue'
// import导入组件工具等
export default {
  components: {
    ImgTips,
  },
  props: ['showDesc'],
  data() {
    return {
      userTips: false,
      notificationKey: '',
    }
  },
  computed: {
    /** gofru(20317) / kingshotru(20349) 不展示 selectTips */
    isRuShop() {
      const gid = String(this.$store.state.app.gameId || '')
      return gid == '20317' || gid == '20349'
    },
  },
  created() {
    this.notificationKey =
      process.env.VUE_APP_GAME_ID == 20195 ? 'game.notification_20195' : 'game.notification'
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.section {
  padding: 0 14px;
}
.tips-content {
  font-size: 13px;
  color: #62676b;
  line-height: 15px;
  position: relative;
  & + .tips-content {
    margin-top: 15px;
  }
}
.btn-link {
  text-decoration: underline;
  font-weight: 400;
  font-family: 'roboto-regular';
}
</style>
